import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { Page } from 'layout'
import { SmartFilter, SmartFilterValues } from 'components/common'

import { TenantActions } from 'models/Tenant/slice'
import { TenantList, TenantForm } from 'models/Tenant/components'
import { TenantCategorySelectField } from 'models/TenantCategory/components'


const filterFields = [
  SmartFilter.getFieldConfig('isActive', 'Активно', SmartFilter.FilterBool),
  SmartFilter.getFieldConfig('category', 'Категория', TenantCategorySelectField),
];


const TenantListPage = () => {
  const dispatch = useDispatch();

  const [params, setParams] = useState(null);

  const onEdit = () => {
    dispatch(TenantActions.openForm({ name: 'editForm' }))
  };
 
  const onFilterChange = (params) => {
    setParams(params)
  }

  return (
    <Page
      title="Арендаторы"
      headerMiddle={<SmartFilter queryKey="tenant" onChange={onFilterChange} fields={filterFields} />}

      mainActions={[
        { name: 'add', action: (detail) => onEdit() },
      ]}

      basePath="/tenant/"
      tabs={[
        { label: 'Арендаторы', key: '' },
        { label: 'Категории', key: 'category/' },
        { label: 'Услуги', key: 'service/' },
      ]}
    >
      <SmartFilterValues queryKey="tenant" onChange={onFilterChange} fields={filterFields} />

      <TenantList params={params} />

      <TenantForm mode="list" />
    </Page >
  )
}

export default TenantListPage
